import * as Sentry from '@sentry/react';
import _debounce from 'lodash/debounce';

// Debounced (leading-edge, 2s window) so a burst of near-simultaneous
// failures - e.g. several files failing in the same batch upload, or a
// retry loop - doesn't spam Sentry with near-duplicate events.
const debouncedCaptureException = _debounce(
  (error: unknown, response?: unknown) => {
    if (response !== undefined) {
      Sentry.captureException(error, { extra: { response } });
    } else {
      Sentry.captureException(error);
    }
  },
  2000,
  { leading: true, trailing: false },
);

export function captureException(error: unknown, response?: unknown) {
  if (response) console.warn(response);
  debouncedCaptureException(error, response);
}
